import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppContextService {
  private origem = '';

  setOrigem(origem: string) {
    this.origem = origem;
  }

  getOrigem(): string {
    return this.origem;
  }
}